import { Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Stack, Tab, Tabs } from '@mui/material';
import { click } from '@testing-library/user-event/dist/click';
import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSchedule } from '../../../slices/orderSlice';
import { customStyles } from '../../../styles';
import { ScheduleAvailable } from './ScheduleAvailable';
import { TabContent } from './TabContent';

export const HeaderTabs = () => {
  const { schedules } = useSelector(state => state.schedules)
  const dispatch = useDispatch()
  const [value, setValue] = useState(0);
  const currentDay = new Date().getDate()
  const currentTime = new Date().getHours()
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleAvailable = (item) => {
    //currentTime > Number(item.start.split(':')[0]) && currentDay !== Number(schedules[value].date.split('-')[2])
    
    if(currentDay === Number(schedules[value].date.split('-')[2]) ){
      if(currentTime > Number(item.start.split(':')[0])) {
        return true
      }
    } else {
      return false
    }
  }
  const allProps = (e, index) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const handleDate = ( date ) => {
    dispatch(setSchedule(date))
  }

  useEffect(() => {
    handleDate(schedules[0])
  }, [])
  return (
    <Box sx={{ width: '100%' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" className="fix-flex">
          {
            schedules?.map((item, index) => (
                <Tab label={item.day} {...allProps(index)} onClick={() => handleDate(item)}/>
            ))
          }
        </Tabs>
      

      <FormControl fullWidth justifyContent="center">
        <FormLabel id="demo-radio-buttons-group-label">Selecciona tu horario.</FormLabel>
        <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue={ schedules[value]?.schedules[0]?.date }
            name="radio-buttons-group"
        >
      <TabContent value={value} index={value} >
            {
              schedules[value]?.schedules.map(item => 
                {
                  return (
                    <FormControlLabel 
                    disabled={ handleAvailable(item) } 
                    value={item.start} 
                    control={<Radio />} 
                    label={`${item.start} - ${item.end}`} 
                    sx={{
                      width: '100%',
                      boxShadow: customStyles.shadows.light,
                      marginBottom: 3,
                      borderRadius: 3
                    }}
                    onClick={() => handleDate(item)}
                    // onChange={() => click(item)}
                    />
                    )
                  }
                  )
                }
             
      </TabContent>
        </RadioGroup>
        </FormControl>
    </Box>
  );
}
